import styled from 'styled-components';
import { MenuItem as MuiMenuItem } from '@mui/material';

export const MenuItem = styled(MuiMenuItem)`
  font-size: 14px;
`;
